import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Trans } from '@lingui/macro';
import styles from './style.css';

class SuccessForgotPassword extends React.Component {
  render() {
    const { changeBy } = this.props.data.forgotPassword;
    return (
      <div className="container">
        <div className="row">
          <div className={`${styles.content}`}>
            <div className={`${styles.image}`}>
              <img
                src={`${
                  changeBy === 'email'
                    ? 'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/email.svg'
                    : 'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/lock.svg'
                }`}
                alt="email"
              />
            </div>
            {changeBy === 'email' && (
              <h2>
                <Trans>Check Your Email</Trans>
              </h2>
            )}
            {changeBy === 'phone' && (
              <h2>
                <Trans>
                  Your password has been
                  <br />
                  changed successfully.
                </Trans>
              </h2>
            )}
            {changeBy === 'email' && (
              <p>
                <Trans>
                  A link to reset your password has been sent to your email.
                </Trans>
              </p>
            )}
            <Link to="/login" className={`${styles.loginBtn}`}>
              <Trans>Back to Sign in</Trans>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(SuccessForgotPassword);
